// ANCHOR React
import { ReactNode } from 'react';

// ANCHOR Base
import {
  SIZE,
  ROLE,
  Modal,
  ModalHeader,
  ModalBody,
} from 'baseui/modal';

// ANCHOR Models
import { useUpdateFormQuestionPositionModalVisibilityStateAndHide } from '@lyon/scoped-models/form/update/UpdateFormQuestionPositionModalVisibility';

// ANCHOR Constants
import { TITLE } from './constants';

interface IProps {
  children: ReactNode;
}

export function LyonUpdateFormPositionModalContainer({ children }: IProps) {
  const [state, hide] = useUpdateFormQuestionPositionModalVisibilityStateAndHide();

  return (
    <Modal
      isOpen={state}
      onClose={hide}
      size={SIZE.default}
      role={ROLE.dialog}
      animate
      autoFocus
      closeable
    >
      <ModalHeader>
        {TITLE}
      </ModalHeader>
      <ModalBody>
        {children}
      </ModalBody>
    </Modal>
  );
}
